import React, { useEffect, useState } from 'react';
import { readWishlist as readLocal, writeWishlist as writeLocal } from './wishlist';

interface Props {
  productId: number;
  productTitle: string;
}

const ProductWishlistButton: React.FC<Props> = ({ productId, productTitle }) => {
  const [inWishlist, setInWishlist] = useState(false);
  const [animate, setAnimate] = useState(false);
  const [loggedIn, setLoggedIn] = useState(false);

  useEffect(() => {
    // Zjisti přihlášení a stav wishlistu
    (async () => {
      let backendIds: number[] | null = null;
      try {
        const meRes = await fetch('/api/me');
        const me = await meRes.json();
        const isLogged = !!me?.data?.logged_in;
        setLoggedIn(isLogged);
        if (isLogged) {
          // Sync local → backend (one-way), pak fetch finální stav
          const local = readLocal();
          if (local.length > 0) {
            await fetch('/api/wishlist?action=sync', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ ids: local }),
            });
          }
          const wlRes = await fetch('/api/wishlist');
          const wl = await wlRes.json();
          if (Array.isArray(wl?.data?.ids)) {
            backendIds = wl.data.ids;
            writeLocal(backendIds || []);
          }
        }
      } catch {}
      const ids = backendIds !== null ? backendIds : readLocal();
      setInWishlist(ids.includes(productId));
    })();
  }, [productId]);

  const toggle = async () => {
    const list = readLocal();
    const isIn = list.includes(productId);
    let next: number[];
    if (!isIn) next = [...list, productId];
    else next = list.filter((x) => x !== productId);
    writeLocal(next);
    setInWishlist(!isIn);
    setAnimate(true);
    setTimeout(() => setAnimate(false), 400);

    if (loggedIn) {
      try {
        if (!isIn) {
          await fetch('/api/wishlist', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: productId }),
          });
        } else {
          await fetch(`/api/wishlist?id=${productId}`, { method: 'DELETE' });
        }
      } catch {}
    }
  };

  return (
    <button
      type="button"
      className={`pd-wishlist${inWishlist ? ' is-active' : ''}${animate ? ' is-animating' : ''}`}
      onClick={toggle}
      aria-label={inWishlist ? `Odebrat „${productTitle}" z oblíbených` : `Přidat „${productTitle}" do oblíbených`}
      title={inWishlist ? 'Odebrat z oblíbených' : 'Přidat do oblíbených'}
    >
      <span className="pd-wishlist__icon" aria-hidden="true">{inWishlist ? '♥' : '♡'}</span>
      <span className="pd-wishlist__label">{inWishlist ? 'V oblíbených' : 'Přidat do oblíbených'}</span>
    </button>
  );
};

export default ProductWishlistButton;
